<script>
import i18n from "../i18n";

export default {
  data() {
    return {
      admin_name: this.admin_name,
      username: "",
      role: this.role,
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English"
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French"
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "spanish"
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese"
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic"
        }
      ],
      current_language: "en"
    };
  },
  // components: { simplebar },
  methods: {
    logout() {
      localStorage.removeItem('moderator_token');
      localStorage.removeItem('moderator_id');
      // localStorage.removeItem('token');
      this.$router.push({ name: 'moderator' });
    },
    
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    setLanguage(locale) {
      i18n.locale = locale;
      this.current_language = i18n.locale;
    },
    getRole() {
      let role = localStorage.getItem('role');
      if (role == 'superadmin') {
        this.$router.push({ name: "dashboard" });
      }
    }
  },
  mounted() {
    this.admin_name = localStorage.getItem('admin_name');
  }
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <div @click="getRole" class="logo logo-dark pointerLogo">
            <span class="logo-sm">
              <img src="/favicon.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo.svg" alt height="20" />
            </span>
          </div>

          <!-- <template v-if=""> -->
          <div @click="getRole" class="logo logo-light pointerLogo">
            <span class="logo-sm">
              <img src="/favicon.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo.svg" alt height="50" />
            </span>
          </div>
          <!-- </template> -->
        </div>

      </div>

      <div class="d-flex">
        <b-button
          variant="link"
          class="header-item d-inline-flex align-items-center p-0"
          @click="logout"
        >
          <img
            class="rounded-circle header-profile-user mr-1"
            src="@/assets/images/user-icon.png"
            alt="User"
          />
          <span class="d-none d-xl-inline-block ml-1">Logout</span>
          <i class="ri-shut-down-line align-middle ml-1"></i>
        </b-button>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.notify-item {
  .active {
    color: #16181b;
    background-color: #f8f9fa;
  }
}

.pointerLogo {
  cursor: pointer;
}
</style>